import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import pt from './locales/pt/translation.json';
import { legalEn, legalEs, legalPt } from './legalContent';

const savedLang = localStorage.getItem('crm-lang') || 'es';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...en, legal: legalEn } },
    es: { translation: { ...es, legal: legalEs } },
    pt: { translation: { ...pt, legal: legalPt } }
  },
  lng: savedLang,
  fallbackLng: 'en',
  supportedLngs: ['es', 'en', 'pt'],
  interpolation: { escapeValue: false }
});

export default i18n;
